//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.js";
import "../no/TaggedObject.js";
let d=[[[0,"AutomaticConstraintDirection",1,0],[0,"AutomaticConstraintType",1,0],[0,"CanInferConstraintFromAttachmentParent",1,0],[0,"Curvature",1,"Offset",0],[0,"CurvatureDerivative",1,"Offset",0],[0,"HasSymmetricModelingConstraint",1,0],[0,"Point",1,"Point",0],[0,"TangentDirection",1,"Direction",0],[0,"TangentMagnitude",1,"Scalar",0]],[],[]];
SPLM.Features.GeometricConstraintData = class extends SPLM.TaggedObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Features.GeometricConstraintData";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Features.GeometricConstraintData.AutoConstraintType = Object.freeze({
    "None" : "None", "Tangent" : "Tangent", "Curvature" : "Curvature", "CurvatureDerivative" : "CurvatureDerivative"});

SPLM.Features.GeometricConstraintData.ParameterDirection = Object.freeze({
    "Iso" : "Iso", "Section" : "Section", "Normal" : "Normal", "Perpendicular" : "Perpendicular"});

export default SPLM;